import React, {useRef, useState} from 'react';
import FilterDropdown, {FilterDropdownRef} from '../../../gallery/components/filters/FilterDropdown';
import FilterLayout from '../../../gallery/components/filters/FilterLayout';
import FilterMultiSelect from '../../../gallery/components/filters/FilterMultiSelect';
import {FilterOption} from '../../../common/types/FilterOption';

interface OrganizationalUnitLevelFilterProps {
  levelLabel: string;
  selectedUnits: string[];
  options: FilterOption[];
  onFilterChange: (selectedUnits: string[]) => void;
}

const OrganizationalUnitLevelFilter: React.FC<OrganizationalUnitLevelFilterProps> = ({
  levelLabel,
  selectedUnits,
  options,
  onFilterChange
}) => {
  const [tempSelectedUnits, setTempSelectedUnits] = useState<string[]>(selectedUnits);
  const filterDropdownRef = useRef<FilterDropdownRef>(null);

  const hasActiveFilter = selectedUnits.length > 0;

  const handleDropdownToggle = (isOpen: boolean) => {
    if (isOpen) {
      setTempSelectedUnits(selectedUnits);
    }
  };

  const applyFilter = () => {
    onFilterChange(tempSelectedUnits);
  };

  const clearFilter = () => {
    setTempSelectedUnits([]);
    onFilterChange([]);
    closeDropdown();
  };

  const closeDropdown = () => {
    filterDropdownRef.current?.close();
  };

  const handleApplyClick = () => {
    applyFilter();
    closeDropdown();
  };

  const handleKeyPress = (event: React.KeyboardEvent) => {
    if (event.key === 'Enter') {
      applyFilter();
      closeDropdown();
    } else if (event.key === 'Escape') {
      setTempSelectedUnits(selectedUnits);
      closeDropdown();
    }
  };

  const getDisplayLabel = () => {
    if (selectedUnits.length === 0) {
      return levelLabel;
    }
    return `${levelLabel} | ${selectedUnits.length}`;
  };

  return (
    <FilterDropdown
      ref={filterDropdownRef}
      label={getDisplayLabel()}
      hasActiveFilter={hasActiveFilter}
      onClearFilter={clearFilter}
      onDropdownToggle={handleDropdownToggle}
    >
      <FilterLayout
        title={`Filter by ${levelLabel}`}
        onClear={clearFilter}
        onApply={handleApplyClick}
      >
        <FilterMultiSelect
          value={tempSelectedUnits}
          options={options}
          onChange={setTempSelectedUnits}
          onKeyDown={handleKeyPress}
        />
      </FilterLayout>
    </FilterDropdown>
  );
};

export default OrganizationalUnitLevelFilter;

